import Vue from "vue"
import global_directives from "~/directives/global.js"

for (let key in global_directives) Vue.directive(key, global_directives[key])

export default {}
